import React, { useState } from 'react';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

type Props = {
	name: string;
	src: string;
};

const Body = ({ name, src }: Props) => {
	const [isLoading, setIsLoading] = useState<boolean>(true);
	return (
		<>
			{isLoading && <Spinner />}
			<iframe
				onLoad={() => setIsLoading(false)}
				frameBorder="0"
				title={name}
				src={src}
				height="100%"
				width="100%"
			/>
		</>
	);
};

export default Body;
